import React from 'react';
import { useMediaQuery } from 'react-responsive';

import Maintitle from './MainTitle';
import MainNav from './MainNav';
import ShowMainNavMobile from './ShowMainNavMobile';

const Header = () => {
    const isLargerThan730 = useMediaQuery({
        query: '(min-width: 730px)'
    });

    return(
        <div id="header">
            <Maintitle />
            {
                isLargerThan730 ?
                    <MainNav />
                :
                    <ShowMainNavMobile />
            }
            
        </div>
    );
};

export default Header;